import { useTenantBranding } from "@/features/tenant-session/model/useTenantBranding";
import { useTenantSlugSync } from "@/features/tenant-session/model/useTenantSlugSync";

/** Mantém a URL e a marca alinhadas com a organização da sessão. Não desenha nada. */
export function TenantSessionSync(): null {
    useTenantSlugSync();
    useTenantBranding();
    return null;
}
